import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { DataCard, DataCardDefaultItem, DataCardListItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { ExpertiseType, SubjectModel } from "../../domain/SubjectModel";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { qualificationLevelsService, qualificationTypesService } from "../../services";
import { RefQualificationTypeModel } from "../../domain/RefQualificationTypeMode";
import { RefQualificationLevelModel } from "../../domain/RefQualificationLevelModel";
import { displayExpertiseTypes, displayAssessmentActivities, displayTeachingActivities } from "../../helpers/subjectHelpers";
import { useRefSubjects } from "../../hooks/useRefSubjects";

export const Subjects: React.FC<{ subjects: SubjectModel[] }> = ({ subjects }) => {

  const { token } = useSelector(authSelector);
  const [qualTypes, setQualTypes] = useState<RefQualificationTypeModel[]>();
  const [qualLevels, setQualLevels] = useState<RefQualificationLevelModel[]>();
  const refSubjects = useRefSubjects(subjects);

  useEffect(() => {
    qualificationTypesService
      .getAll({ token })
      .then((response) =>
        setQualTypes(response as RefQualificationTypeModel[])
      );
  }, [token]);

  useEffect(() => {
    qualificationLevelsService
      .getAll({ token })
      .then((response) =>
        setQualLevels(response as RefQualificationLevelModel[])
      );
  }, [token]);

  const subjectTitleGenerator = (id: number): string => {
    let title: string = "";
    if (refSubjects.length > 0) {
      title = refSubjects.find((s) => id === s.id)?.subjectTitle ?? refSubjects.find((s) => id === s.id)?.ssaDescription2 ?? "cant find";
    }
    return title
  }

  const displaySubjects = (subject: SubjectModel) => {

    let subjectTitle = subjectTitleGenerator(subject.subjectId)
    let qualTypeDescription = "I don't know the qualification type";
    let qualLevelsDescription = ["I don't know the level"];

    if (qualTypes !== undefined) {
      var qlist = qualTypes.filter(x => x.id === subject.qualificationTypeId)
      if (qlist.length > 0) {
        qualTypeDescription = qlist[0].code === "GceAsLevel" ? "GCE AS/A level" : qlist[0].description;
      }

    }

    if (qualLevels !== undefined) {
      var selectedQualLevels = qualLevels.filter(q => subject.qualificationLevels.some(s => s.levelId === q.id));
      if (selectedQualLevels.length > 0)
        qualLevelsDescription = selectedQualLevels.map(s => s.levelDescription);
    }

    const items: (DataCardDefaultItem | DataCardListItem)[] = [
      {
        itemType: "DEFAULT",
        key: "Subject",
        value: subjectTitle,
      },
      {
        itemType: "DEFAULT",
        key: "Qualification type",
        value: qualTypeDescription,
      },
      {
        itemType: "LIST",
        key: "Qualification level",
        value: qualLevelsDescription,
      },
      {
        itemType: "LIST",
        key:
          "What type(s) of experience do you have for this subject or occupational area?",
        value: displayExpertiseTypes(subject.expertiseType),
      },
    ];

    if (subject.expertiseType & ExpertiseType.Assessment) {
      items.push(
        {
          itemType: "LIST",
          key: "Which assessment activities or responsibilities are you experienced in for this subject or occupational area?",
          value: displayAssessmentActivities(subject.selectedAssessmentActivities)
        }
      )
    }

    if (subject.expertiseType & ExpertiseType.Teaching) {
      items.push(
        {
          itemType: "LIST",
          key: "Which teaching, lecturing or training activities or responsibilities are you experienced in for this subject or occupational area?",
          value: displayTeachingActivities(subject.teachingActivity)
        }
      )
    }

    return items
  }

  return (
    <>

      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {
              subjects.map((subject, index) => {
                return (
                  <React.Fragment key={index}>
                    {index > 0 ? <br /> : <></>}
                    <DataCard
                      showHeading={true}
                      heading={subjectTitleGenerator(subject.subjectId)}
                      items={displaySubjects(subject)}
                      hasAction={false}
                      actionDescription={null}
                      actionButtonText={null}
                      actionFunction={null}
                      headingComponent={"h1"}
                    />
                  </React.Fragment>
                );
              })
            }
          </Grid>
        </Grid>
      </div>
    </>
  );
};

